.updateBadge {
    cursor: pointer;
}
